export default __webpack_public_path__ + "static/media/Snd_CD.79fb3f3b.mp3";